<template>
  <div class="team">
    <div class="team-nav">
      <div class="control">
        <div class="control-search">
          <span>战队名称：</span>
          <div class="search-input">
            <el-input
              size="small"
              type="text"
              v-model="name"
              placeholder="请输入战队名称"
            ></el-input>
          </div>
          <div class="search-select">
            <el-select size="small" v-model="status" placeholder="请选择">
              <el-option
                v-for="item in teamStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search-select">
          <span>段位：</span>
            <el-select size="small" v-model="grade" placeholder="请选择">
              <el-option
                label="全部"
                value=""
              ></el-option>
              <el-option
                v-for="item in danList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-button
            size="small"
            type="primary"
            class="search-but1"
            @click="handleSearch()"
          >
            查询
          </el-button>
          <el-button size="small" @click="handleReset">重置</el-button>
        </div>

        <div>
          <el-button size="small" type="primary" @click="handleDownload">
            下载导入模板
          </el-button>
        </div>
      </div>

      <div>
        <el-button size="small" type="primary" @click="openDialog('add')">
          添加
        </el-button>
        <el-button size="small" type="primary" @click="handleImport">
          导入战队
        </el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="dataSource"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in tableColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
        >
          <template slot-scope="scope">
            {{ tableTranslation(item.prop, scope.row) }}
          </template>
        </el-table-column>

        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="150"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDissolve(scope.row)"
              :disabled="scope.row.status === 2"
            >
              解散
            </el-button>
            <el-button type="text" @click="openDialog('editor', scope.row)">
              编辑
            </el-button>
            <el-button type="text" @click="openPkDialog(scope.row)">
              查看PK记录
            </el-button>
            <el-button type="text" @click="handleDel(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <user-dialog
      v-if="dialogFlag"
      :openType="dialogType"
      :defaultData="dialogData"
      :handleClose="handleDialogClose"
    />

    <view-pk-record
      v-if="pkDialogFlag"
      :handleClose="handlePkDialogClose"
      :defaultData="pkDialogData"
    />

    <import-team
      v-if="importDialogFlag"
      :handleClose="handleImportDialogClose"
    />
  </div>
</template>
<script>
import {
  danList,
  teamStatusList,
  teamColumn,
  translationDan,
  translationStatus,
} from "./components/assets";
import * as API from "@/api/season/vip.js";
import UserDialog from "./components/teamDialog.vue";
import ViewPkRecord from "./components/viewPkRecord.vue";
import ImportDialog from "./components/importTeam.vue";

export default {
  components: {
    ["user-dialog"]: UserDialog,
    ["view-pk-record"]: ViewPkRecord,
    ["import-team"]: ImportDialog,
  },
  data() {
    return {
      tableColumn: teamColumn,
      name: "",
      status: "1",
      grade: '',
      teamStatusList,
      danList,
      page: 1,
      limit: 10,
      total: 0,
      dataSource: [],
      loading: false,
      dialogFlag: false,
      dialogData: {},
      dialogType: null,
      pkDialogFlag: false,
      pkDialogData: {},
      importDialogFlag: false,
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    tableTranslation(prop, rowData) {
      switch (prop) {
        case "grade":
          return translationDan(rowData[prop]);
        case "status":
          return translationStatus(rowData[prop]);
          return;
        default:
          return rowData[prop];
      }
    },
    handleSearch() {
      this.page = 1;
      this.getDataSource();
    },
    handleReset() {
      this.name = "";
      this.status = "all";
      this.page = 1;
      this.getDataSource();
    },
    async getDataSource() {
      this.loading = true;
      const { name, status, page, limit, grade } = this;
      const params = {
        name,
        status: status === "all" ? undefined : status,
        page,
        limit,
        grade
      };
      try {
        const res = await API.getTeamList(params);
        const { code, data } = res;
        if (code === 0 && data) {
          const { total, records = [] } = data;
          this.total = Number(total);
          this.dataSource = records;
        }
      } catch (error) {
        this.dataSource = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleDissolve(rowData) {
      this.$confirm("确定要解散当前战队吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          try {
            const res = await API.dissolveTeam({}, rowData.id);
            const { code } = res;
            if (code === 0) {
              this.$message.success("解散成功！");
              this.getDataSource();
            }
          } catch (error) {
            //防止request返回reject
          }
        })
        .catch(() => {});
    },
    handleLimitChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.getDataSource();
    },
    handlePageChange(page) {
      this.page = page;
      this.getDataSource();
    },
    openDialog(type, rowData = {}) {
      this.dialogType = type;
      this.dialogData = rowData;
      this.dialogFlag = true;
    },
    handleDialogClose(isReset) {
      this.dialogFlag = false;
      //新增从第一页请求，编辑保留当前搜索项
      switch (isReset) {
        case 0:
          break;
        case 1:
          this.handleReset();
          break;
        case 2:
          this.getDataSource();
          break;
        default:
          break;
      }
    },
    openPkDialog(rowData) {
      this.pkDialogData = rowData;
      this.pkDialogFlag = true;
    },
    handlePkDialogClose() {
      this.pkDialogFlag = false;
    },
    handleDownload() {
      const openUrl =
        process.env.NODE_ENV === "development"
          ? "https://t1-jsapi.gzjushiwang.com/activity/adm/seasonTeam/exportSeasonTeamSale"
          : process.env.VUE_APP_BASEURL +
            "/activity/adm/seasonTeam/exportSeasonTeamSale";
      window.open(openUrl);
    },
    handleImport() {
      this.importDialogFlag = true;
    },
    handleImportDialogClose(isReset) {
      this.importDialogFlag = false;
      if (isReset) this.handleReset();
    },
    handleDel(rowData) {
      this.$confirm("确定要删除当前战队吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          try {
            const res = await API.delTeam({}, rowData.id);
            const { code } = res;
            if (code === 0) {
              this.$message.success("删除成功！");
              this.getDataSource();
            }
          } catch (error) {
            //防止request返回reject
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="scss">
.team {
  .team-nav {
    padding: 20px;
    margin-bottom: 20px;
    background: #fff;
    .control {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .control-search {
        display: flex;
        align-items: center;
        .search-input {
          margin-right: 20px;
        }
        .search-select {
          margin-right: 20px;
        }
        .search-but1 {
          margin-right: 10px;
        }
      }
    }
  }
  .table {
    margin-bottom: 20px;
  }

  .pagination {
    text-align: right;
  }
}
</style>
